<div class="dots" [class]="optionClasses">
  <div class="dot"></div>
  <div class="dot"></div>
  <div class="dot"></div>
</div>
